import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqDialogComponent } from './faq-dialog/faq-dialog.component';
import { FaqListComponent } from './faq-list/faq-list.component';
import { FormsModule } from '@angular/forms';
import { MaterialAppModule } from 'src/app/material.module';
import { FilterFaqPipe } from './faq-list/filter-faq.pipe';

@NgModule({
  declarations: [
    FaqListComponent,
    FaqDialogComponent,
    FilterFaqPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialAppModule
  ],
  exports: [
    FaqListComponent,
    FaqDialogComponent,
    FilterFaqPipe
  ]
})
export class FaqSharedModule { }